import { render, staticRenderFns } from "./BtCalculatedTable.vue?vue&type=template&id=0544f2d2&"
import script from "./BtCalculatedTable.vue?vue&type=script&lang=js&"
export * from "./BtCalculatedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports